import { MouseEvent, useState } from 'react';
import { Popover, TooltipProps } from '@ets/design-system';
import styles from './PopperTooltip.module.scss';

type PopperTooltipProps = TooltipProps;

const PopperTooltip = ({ children, content, testId, placement = 'bottom' }: PopperTooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const showToolTip = (e: MouseEvent<HTMLDivElement>) => {
    return e.currentTarget.scrollWidth > e.currentTarget.clientWidth;
  };

  return (
    <Popover.Root placement={placement} open={isOpen}>
      <Popover.Trigger asChild>
        <div
          className={styles.ellipsis}
          onMouseEnter={(e) => {
            showToolTip(e) && setIsOpen(true);
          }}
          onMouseLeave={() => setIsOpen(false)}
        >
          {children}
        </div>
      </Popover.Trigger>
      <Popover.Content testId="tooltip" className={styles.tooltip}>
        <div data-testid={testId}>{content}</div>
      </Popover.Content>
    </Popover.Root>
  );
};

export default PopperTooltip;
